import Vue from "vue";

let contrastActive = false;

const isContrastModeOn = () => {
    const contrastOn = Vue.$localStorage.get("contrast");
    contrastActive = contrastOn === true;
    return contrastActive;
}

const switchContrast = () => {
    Vue.$localStorage.set('contrast', !contrastActive);
    contrastActive = !contrastActive;
    return contrastActive;
}

export const contrastService = {
    isContrastModeOn,
    switchContrast
};
